import type {ReactNode} from 'react';

import css from './Tag.module.css';

export type TagTone = 'neutral' | 'accent' | 'success' | 'warning' | 'error';

interface TagProps {
	tone?: TagTone;
	withDot?: boolean;
	className?: string;
	/**
	 * Нативная подсказка. Метка коротка по устройству — два-три слова, — и там, где
	 * за ними стоит последствие, объяснить его больше негде: строку рядом занимает
	 * то, что метка помечает.
	 */
	title?: string;
	children: ReactNode;
}

export function Tag({tone = 'neutral', withDot, className, title, children}: TagProps) {
	return (
		<span className={[css.root, css[tone], className].filter(Boolean).join(' ')} title={title}>
			{withDot ? <span className={css.dot} /> : null}
			{children}
		</span>
	);
}
